module.exports = __webpack_public_path__ + "img/traveloka-form-bk.8e8d966.png";